import React, { useEffect, useState } from 'react'
import className from 'classnames/bind'
import { useLocation } from 'react-router-dom'

import MyhouseAttachmentTooltip from '../MyhouseAttachmentTooltip'

import style from './MyhouseAuthPackageConfirm.module.scss'

import BlindContent from '@Components/atoms/BlindContent'
import { IMAGE_ACCEPT_TYPE } from '@Root/contants/myhouseRegister'
import useMediaViewer from '@Hooks/mediaViewer/useMediaViewer'
import { handleNclick, handleNclickMix } from '@Helpers/nclick'
import { NCLICK } from '@Root/contants/lcs'

const cx = className.bind(style)

type Props = {
  onRetakePictureChange: any
  onUsePictureClick: any
  previewURL: any
}

const MyhouseAuthPackageConfirm: React.FC<Props> = ({ onRetakePictureChange, onUsePictureClick, previewURL }: Props) => {
  const { useAuthMediaViewer } = useMediaViewer()
  const { open } = useAuthMediaViewer([
    {
      url: previewURL,
      svcName: '네이버페이 부동산 우리집',
      desc: '입주민 인증 - 택배/우편물 촬영',
    },
  ])

  const imageClickHandler = (index: number) => (event: React.SyntheticEvent) => {
    event.preventDefault()
    event.stopPropagation()
    handleNclick(NCLICK.MY_HOUSE.AUTHENTICATION.RESIDENT_PACKAGE_CONFIRM.IMAGE_VIEWER, event)

    open(index)
  }

  const [isShow, setIsShow] = useState(false)

  return (
    <section id="content" className={cx('article', 'type_package')} role="main">
      <BlindContent />
      <div className={cx('inner')}>
        <h3 className={cx('title')}>
          정상적으로 촬영되었는지
          <br /> 확인해 주세요.
        </h3>
        <p className={cx('text')}>성명, 주소지 정보가 식별되는지 확인해 주세요. 흔들림, 빛 번짐, 글자를 알아보기 힘든 경우엔 인증이 반려될 수 있습니다.</p>
        <button type="button" className={cx('button_guideline')} onClick={handleNclickMix(NCLICK.MY_HOUSE.AUTHENTICATION.RESIDENT_PACKAGE_CONFIRM.GUIDE, () => setIsShow(true))}>
          파일첨부 가이드라인
        </button>
        <div className={cx('wrap_image')} onClick={imageClickHandler(0)}>
          <img src={previewURL} className={cx('image')} alt="택배" />
        </div>
        <MyhouseAttachmentTooltip isShow={isShow} setIsShow={setIsShow} />
      </div>
      <div className={cx('util')}>
        <span className={cx('photo')}>
          <input id="input_photo" type="file" accept={IMAGE_ACCEPT_TYPE} onChange={onRetakePictureChange} className="blind" />
          <label htmlFor="input_photo" className={cx('label')}>
            다시 촬영하기
          </label>
        </span>
        <button type="button" onClick={onUsePictureClick} className={cx('button_auth')}>
          인증 신청하기
        </button>
      </div>
    </section>
  )
}

export default MyhouseAuthPackageConfirm
